import { Link } from 'react-router';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useT } from '../i18n';
import './Home.css';

export function Home() {
  const t = useT();
  useDocumentTitle('');
  return (
    <div className="home">
      {/* The lake is the page: the render fills the screen and the words stand on the dark water. */}
      <section className="home-hero" aria-labelledby="home-title">
        <img
          className="home-heroImage"
          src="/lake-wide.webp"
          width={2400}
          height={1500}
          alt={t.home.picture}
        />
        <div className="home-heroText">
          <h1 id="home-title" className="home-title">
            {t.home.tagline}
          </h1>
          <p className="home-lead">{t.home.lead}</p>
          <div className="home-actions">
            <Link to="/play/bot" className="btn btn-primary btn-large">
              {t.home.playBot}
            </Link>
            <Link to="/play/online" className="btn btn-large">
              {t.home.playOnline}
            </Link>
          </div>
          <p className="home-more">
            <Link to="/learn" className="link-quiet">
              {t.home.learn}
            </Link>
            <span aria-hidden="true">·</span>
            <Link to="/play/local" className="link-quiet">
              {t.home.playLocal}
            </Link>
          </p>
        </div>
      </section>

      <section className="home-how" aria-labelledby="home-how-title">
        <h2 id="home-how-title" className="home-howTitle">
          {t.home.factsTitle}
        </h2>
        <div className="home-shots">
          {t.home.facts.map((fact) => (
            <figure key={fact.image} className="home-shot">
              <img src={fact.image} alt={fact.alt} loading="lazy" />
              <figcaption>
                <h3>{fact.title}</h3>
                <p>{fact.body}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
}
